import { render, staticRenderFns } from "./GatForm.vue?vue&type=template&id=0d7ad1c2&scoped=true"
import script from "./GatForm.vue?vue&type=script&lang=js"
export * from "./GatForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ad1c2",
  null
  
)

export default component.exports